import {
  type InfiniteData,
  useInfiniteQuery,
  type UseInfiniteQueryResult,
} from '@tanstack/react-query';
import type { BankOperationPage, BankOperationsFilter } from '../../model/bank-operation.js';
import { bankTransactionQueries } from './bank-transaction-queries.js';

export const useBankOperationsQuery = (
  filter: BankOperationsFilter,
): UseInfiniteQueryResult<InfiniteData<BankOperationPage>> =>
  useInfiniteQuery(bankTransactionQueries.list(filter));
